module.exports = __webpack_public_path__ + "static/img/shangsheng.f8ee6700.svg";